import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      width="15"
      height="13"
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 5.70588L5.13636 11L14 1" stroke={fill} strokeWidth="2" />
    </svg>
  );
};

export default memo(Icon);
